import medusa from '@/scripts/medusa';

export default {
  // When the bound element is inserted into the DOM...
  inserted(el) {
    medusa.ref.pushToTarget('lazyLoading', el);
  },
  unbind(el) {
    if (el.hasAttribute('data-src')) medusa.ref.pullFromTarget('lazyLoading', el);
  },
};
